"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionMoreActions_1 = require("../../../../../../shared/components/table_actions/TableActionMoreActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var alasql = require("alasql");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var ButtonDoExportXLS_1 = require("../../../../../../shared/components/buttons/ButtonDoExportXLS");
var PlayerDetailExpander_1 = require("./expander/PlayerDetailExpander");
var PlayersList = /** @class */ (function (_super) {
    __extends(PlayersList, _super);
    function PlayersList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchLoginInput = null;
        _this.searchEMailInput = null;
        _this.action_more_get_pass = "action:get-password";
        _this.action_more_set_pass = "action:set-password";
        _this.action_more_do_export = "action:do-export";
        _this.action_more_change_streamer_balance = "action:change-streamer-balance";
        _this.ACTION_NEW_PLAYER = "action:new-player";
        _this.ACTION_NEW_BROADCAST_RAW = "action:new-broadcast-raw";
        _this.ACTION_EXPORT_PLAYERS = "action:export-players";
        _this.ACTION_EXPORT_SUBSCRIBERS = "action:export-subscribers";
        //private readonly ACTION_NEW_BROADCAST_TPL = "action:new-broadcast-tpl";
        _this.LOGIN_FILTER = "PlayersList-LoginFilter";
        _this.EMAIL_FILTER = "PlayersList-EmailFilter";
        _this.PAGE_NUM_ONE = 1;
        return _this;
    }
    PlayersList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    PlayersList.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.LOGIN_FILTER);
        }
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.EMAIL_FILTER);
        }
        this.setState({
            searchLoginFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).selectedValues,
            searchLoginValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).filterValue,
            isSearchLogin: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).isFilterActive,
            searchEMailFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).selectedValues,
            searchEMailValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).filterValue,
            isSearchEmail: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).isFilterActive,
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                currency_filter: data.currency_filter,
                language_filter: data.language_filter,
                level_filter: data.level_filter
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            currency_filter: [],
            language_filter: [],
            level_filter: []
        }, function () {
            _this.doReLoadPlayersList();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    PlayersList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PlayersList.prototype.doReLoadPlayersList = function (cb) {
        // alert(`doReLoadPlayersList -> offset -> ${this.getDataOffset()}; limit -> ${this.state.pageSize}`);
        this.props.data.LoadFilteredData({
            allBrands: this.props.allBrands,
            brandIdList: this.props.brandsList,
            allTags: this.props.allTags,
            tagIdList: this.props.tagsList,
            Offset: this.getDataOffset(),
            Limit: this.state.pageSize,
            isFilterEmailPart: this.state.isSearchEmail,
            emailPart: this.state.searchEMailValue,
            isFilterLoginPart: this.state.isSearchLogin,
            loginPart: this.state.searchLoginValue
        }, function () {
            if (cb) {
                cb();
            }
        });
    };
    PlayersList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                _this.doReLoadPlayersList();
            });
        }
    };
    //http://jsfiddle.net/sujit77/9d6yrom9/69/
    //https://github.com/SheetJS/js-xlsx
    PlayersList.prototype.doMoreAction = function (e, record) {
        var _this = this;
        if (e.key == this.action_more_get_pass) {
            this.props.data.GetPlayerPassword(record.key, function (pass) {
                _this.props.dlgView.SetTitle("\u041F\u0430\u0440\u043E\u043B\u044C \u0438\u0433\u0440\u043E\u043A\u0430 : " + record.login + " ").SetText(pass).Show();
            });
        }
        if (e.key == this.action_more_set_pass) {
            this.props.dlgPwd.clearFields().SetOnYesClick(function (newpass) {
                _this.props.data.SetPlayerNewPassword(record.key, newpass, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u0438\u0433\u0440\u043E\u043A\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.login,
                            "]"),
                        " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
                });
            }).Show();
        }
        if (e.key == this.action_more_change_streamer_balance) {
            if (!record.is_streamer) {
                notificationHelper_1.default.ShowTextTopRightErrorNotify("Изменение баланса доступно только для стримеров!");
            }
            else {
                this.props.DlgNumericEditor.SetTitle("Изменить баланс стримера").SetOnCloseClick(function () { _this.props.DlgNumericEditor.Close(); }).SetOnYesClick(function (val) {
                    _this.props.data.doChangePlayerStreamerBalance(record.key, val, function () {
                        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                            "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043B\u044F \u0441\u0442\u0440\u0438\u043C\u0435\u0440\u0430 ",
                            React.createElement("b", null,
                                "[",
                                record.login,
                                "]"),
                            " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
                        _this.props.DlgNumericEditor.Close();
                    });
                }).SetInputCaption("Новый баланс").SetInputPlaceHolder("Введите новый баланс").SetMinValue(0).SetMaxValue(9999999).Show();
            }
        }
    };
    PlayersList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMoreAction(e, record); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_more_get_pass },
                React.createElement(FontAwesome_1.FA, { icon: "eye", left: true }),
                "\u0423\u0437\u043D\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_pass },
                React.createElement(FontAwesome_1.FA, { icon: "key", left: true }),
                "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_change_streamer_balance },
                React.createElement(FontAwesome_1.FA, { icon: "dollar-sign", left: true }),
                "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0431\u0430\u043B\u0430\u043D\u0441")));
    };
    PlayersList.prototype.doNewAction = function (e) {
        if (e.key == this.ACTION_NEW_PLAYER) {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
            return;
        }
        if (e.key == this.ACTION_NEW_BROADCAST_RAW) {
            if (this.props.onSendBroadcastRawClick) {
                this.props.onSendBroadcastRawClick();
            }
            return;
        }
        /*if(e.key == this.ACTION_NEW_BROADCAST_TPL) {
            if(this.props.onSendBroadcastTplClick) {
                this.props.onSendBroadcastTplClick();
            }
        }*/
        console.log("new action -> " + e.key);
    };
    PlayersList.prototype.getNewButtonActionsDropDownMenu = function () {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doNewAction(e); } },
            React.createElement(antd_1.Menu.Item, { key: this.ACTION_NEW_PLAYER },
                React.createElement(FontAwesome_1.FA, { icon: "eye", left: true }),
                "\u041D\u043E\u0432\u044B\u0439 \u0438\u0433\u0440\u043E\u043A"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.ACTION_NEW_BROADCAST_RAW },
                React.createElement(FontAwesome_1.FA, { icon: "comment-alt", left: true }),
                "\u041D\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435")));
    };
    PlayersList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetPlayerIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u043E\u043A ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u043E\u043A ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PlayersList.prototype.onClearLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [],
            searchLoginValue: "",
            isSearchLogin: false,
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.LOGIN_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.LOGIN_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.LOGIN_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
        });
    };
    PlayersList.prototype.onClearEMailFilter = function () {
        var _this = this;
        this.setState({
            searchEMailFilter: [],
            searchEMailValue: "",
            isSearchEmail: false
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.EMAIL_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.EMAIL_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.EMAIL_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
        });
    };
    PlayersList.prototype.onChangeLoginFilter = function (e) {
        var _this = this;
        this.setState({
            searchLoginValue: e.target.value
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.LOGIN_FILTER, _this.state.searchLoginValue);
        });
    };
    PlayersList.prototype.onChangeEMailFilter = function (e) {
        var _this = this;
        this.setState({
            searchEMailValue: e.target.value
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.EMAIL_FILTER, _this.state.searchEMailValue);
        });
    };
    PlayersList.prototype.onConfirmLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [this.state.searchLoginValue],
            isSearchLogin: true,
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.LOGIN_FILTER, [_this.state.searchLoginValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.LOGIN_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
        });
    };
    PlayersList.prototype.onConfirmEMailFilter = function () {
        var _this = this;
        this.setState({
            searchEMailFilter: [this.state.searchEMailValue],
            isSearchEmail: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.EMAIL_FILTER, [_this.state.searchEMailValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.EMAIL_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
            // this.doReLoadPlayersList();
        });
    };
    PlayersList.prototype.getPlayerTags = function (record) {
        var _ret = [];
        for (var i = 0; i < record.player_tags.length; i++) {
            _ret.push(React.createElement(antd_1.Tooltip, { title: record.player_tags[i].title, key: i },
                React.createElement(antd_1.Tag, { color: record.player_tags[i].color }, record.player_tags[i].code)));
        }
        return _ret;
    };
    PlayersList.prototype.getCustomAttributes = function (record) {
        var arr_attr = [];
        if (record.is_custom_zone) {
            arr_attr.push(React.createElement(FontAwesome_1.FA, { right: true, icon: "percent" }));
        }
        if (record.is_suspicious) {
            arr_attr.push(React.createElement(FontAwesome_1.FA, { right: true, icon: "exclamation-triangle" }));
        }
        return (React.createElement("span", { style: { color: "red" } }, arr_attr));
    };
    PlayersList.prototype.getIconLogin = function () {
        if (!this.state.isSearchLogin) {
            return "search";
        }
        else {
            return "close-circle";
        }
    };
    PlayersList.prototype.getIconEmail = function () {
        if (!this.state.isSearchEmail) {
            return "search";
        }
        else {
            return "close-circle";
        }
    };
    PlayersList.prototype.getColumns = function () {
        var _this = this;
        var _login_filter = this.state.searchLoginFilter;
        var _email_filter = this.state.searchEMailFilter;
        return ([{
                title: 'Логин',
                dataIndex: this.props.data.dk_login,
                key: this.props.data.dk_login,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchLoginInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043B\u043E\u0433\u0438\u043D\u0443", value: _this.state.searchLoginValue, onChange: _this.onChangeLoginFilter.bind(_this), onPressEnter: function () { _this.onConfirmLoginFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmLoginFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearLoginFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _login_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: _this.getIconLogin(), style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.login.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchLoginInput.focus();
                        });
                    }
                },
                render: function (text, record, idx) {
                    if (record.is_bot) {
                        return (React.createElement("div", { title: "\u0411\u043E\u0442" },
                            React.createElement("span", { style: { color: "#DD164C" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "robot" })),
                            " ",
                            record.login,
                            " ",
                            _this.getCustomAttributes(record)));
                    }
                    if (record.is_streamer) {
                        return (React.createElement("div", { title: "\u0421\u0442\u0440\u0438\u043C\u0435\u0440" },
                            React.createElement("span", { style: { color: "#DD164C" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "desktop" })),
                            " ",
                            record.login,
                            " ",
                            _this.getCustomAttributes(record)));
                    }
                    if (record.is_developer) {
                        return (React.createElement("div", { title: "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A" },
                            React.createElement("span", { style: { color: "#DD164C" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "laptop-code" })),
                            " ",
                            record.login,
                            " ",
                            _this.getCustomAttributes(record)));
                    }
                    return (React.createElement("div", { title: "\u0418\u0433\u0440\u043E\u043A" },
                        React.createElement("span", { style: { color: "" + record.trust_zone_color } },
                            React.createElement(FontAwesome_1.FA, { right: true, icon: "user" })),
                        " ",
                        record.login,
                        " ",
                        _this.getCustomAttributes(record)));
                }
            }, {
                title: 'EMail',
                dataIndex: this.props.data.dk_email,
                key: this.props.data.dk_email,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchEMailInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0435\u043C\u044D\u0439\u043B", value: _this.state.searchEMailValue, onChange: _this.onChangeEMailFilter.bind(_this), onPressEnter: function () { _this.onConfirmEMailFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmEMailFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearEMailFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _email_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: _this.getIconEmail(), style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.email.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchEMailInput.focus();
                        });
                    }
                },
                width: 150,
                render: function (text, record, idx) {
                    if (record.is_email_confirmed) {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "green" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                            " ",
                            record.email));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "red" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                            " ",
                            record.email));
                    }
                },
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_currency_title,
                key: this.props.data.dk_currency_title,
                width: 120,
                align: "center",
                filters: this.state.currency_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.app_currency_title.includes(value); },
            }, {
                title: 'Язык/TZ',
                dataIndex: this.props.data.dk_language_title,
                key: this.props.data.dk_language_title,
                width: 120,
                align: "center",
                filters: this.state.language_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.app_language_title.includes(value); },
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.app_language_title,
                        "/",
                        record.time_zone_offset_hours,
                        " \u0447."));
                },
            }, {
                title: 'Уровень',
                dataIndex: this.props.data.dk_bonus_level_title,
                key: this.props.data.dk_bonus_level_title,
                width: 140,
                align: "center",
                filters: this.state.level_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.bonus_level_title.includes(value); },
            }, {
                title: 'Баланс (Д/П/Б)',
                dataIndex: this.props.data.dk_money_balance,
                key: this.props.data.dk_money_balance,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.money_balance),
                        "/",
                        UIUtils_1.UIUtils.formatCurrency(record.points_balance),
                        "/",
                        UIUtils_1.UIUtils.formatCurrency(record.bonus_balance)));
                },
                width: 150,
            }, {
                title: 'Геоданные игрока',
                dataIndex: this.props.data.dk_fathername,
                key: this.props.data.dk_fathername,
                render: function (text, record, index) {
                    return (React.createElement("span", null,
                        record.by_ip_country_code,
                        ".",
                        record.by_ip_city,
                        ".",
                        record.by_ip_organisation));
                },
                width: 200,
                align: "left"
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать игрока", text: "Да" }, unlockedTexts: { menu: "Разблокировать игрока", text: "Нет" }, record: { key: record.key, title: record.login, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 120,
            },
            {
                title: 'Добавлен',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                },
                width: 140,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onGoToOperationsListClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }),
                    React.createElement(TableActionMoreActions_1.default, { hint: "\u0415\u0449\u0435", menu: _this.getMoreActionsDropDownMenu(record) }))); },
                width: 130
            }
        ]);
    };
    PlayersList.prototype.onGoToOperationsListClick = function (record) {
        if (this.props.onGoToOperationsListClick) {
            this.props.onGoToOperationsListClick(record);
        }
    };
    PlayersList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    PlayersList.prototype.onDeletePlayerClick = function (record) {
        var _this = this;
        this.props.data.DeletePlayer(record.key, function () {
            _this.doReLoadPlayersList(function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u043E\u043A ",
                    React.createElement("b", null,
                        "[",
                        record.login,
                        "]"),
                    " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
            });
        });
    };
    PlayersList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_page, _PageSize);
            }
        });
    };
    PlayersList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.doReLoadPlayersList();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    PlayersList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    PlayersList.prototype.onTagFilterChanged = function (allTags, TagId, Action) {
        if (this.props.onTagFilterChanged) {
            this.props.onTagFilterChanged(allTags, TagId, Action);
        }
    };
    PlayersList.prototype.bool2Str = function (val) {
        if (val) {
            return "ДА";
        }
        else {
            return "НЕТ";
        }
    };
    PlayersList.prototype.doExportAllPlayers = function () {
        var _this = this;
        this.props.dlgExport
            .clearFields()
            .SetDialogTitle("Экспорт списка игроков")
            .SetOnYesClick(function (exportFormat) {
            _this.props.data.doExportObjectArray(_this.props.allBrands, _this.props.brandsList, function (data) {
                if (exportFormat === "XLSX") {
                    var opts = [{ sheetid: 'All Players list', header: true }];
                    var result = alasql('SELECT * INTO XLSX("exported_players_list.xlsx",?) FROM ?', [opts, [data]]);
                }
                if (exportFormat === "CSV") {
                    var result = alasql('SELECT * INTO CSV("exported_players_list.csv", {headers:true}) FROM ?', [data]);
                }
                if (exportFormat === "JSON") {
                    var result = alasql('SELECT * INTO JSON("exported_players_list.json", {headers:false}) FROM ?', [data]);
                }
                if (exportFormat === "TXT") {
                    var result = alasql('SELECT * INTO TAB("exported_players_list.txt", {headers:true}) FROM ?', [data]);
                }
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 ",
                    React.createElement("b", null,
                        "[",
                        exportFormat,
                        "]"),
                    " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D !"));
            });
        }).Show();
    };
    PlayersList.prototype.doExportSubscribedPlayers = function () {
        var _this = this;
        this.props.dlgExport
            .clearFields()
            .SetDialogTitle("Экспорт игроков подписанных на рассылку")
            .SetOnYesClick(function (exportFormat) {
            _this.props.data.doExportSubscribedObjectArray(_this.props.allBrands, _this.props.brandsList, function (data) {
                if (exportFormat === "XLSX") {
                    var opts = [{ sheetid: 'Subscribed Players list', header: true }];
                    var result = alasql('SELECT * INTO XLSX("exported_players_list.xlsx",?) FROM ?', [opts, [data]]);
                }
                if (exportFormat === "CSV") {
                    var result = alasql('SELECT * INTO CSV("exported_players_list.csv", {headers:true}) FROM ?', [data]);
                }
                if (exportFormat === "JSON") {
                    var result = alasql('SELECT * INTO JSON("exported_players_list.json", {headers:false}) FROM ?', [data]);
                }
                if (exportFormat === "TXT") {
                    var result = alasql('SELECT * INTO TAB("exported_players_list.txt", {headers:true}) FROM ?', [data]);
                }
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 ",
                    React.createElement("b", null,
                        "[",
                        exportFormat,
                        "]"),
                    " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D !"));
            });
        }).Show();
    };
    PlayersList.prototype.getSelfExcludeText = function (rec) {
        if (rec.is_self_exclude) {
            return rec.self_exclude_date.format(this.props.state.getDateTimeFormat());
        }
        else {
            return "НЕТ";
        }
    };
    //private readonly ACTION_EXPORT_PLAYERS = "action:export-players";
    //private readonly ACTION_EXPORT_SUBSCRIBERS = "action:export-subscribers";
    PlayersList.prototype.doExportAction = function (e) {
        if (e.key == this.ACTION_EXPORT_PLAYERS) {
            this.doExportAllPlayers();
            return;
        }
        if (e.key == this.ACTION_EXPORT_SUBSCRIBERS) {
            this.doExportSubscribedPlayers();
            return;
        }
        console.log("export action -> " + e.key);
    };
    PlayersList.prototype.getExportActionsDropDownMenu = function () {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doExportAction(e); } },
            React.createElement(antd_1.Menu.Item, { key: this.ACTION_EXPORT_PLAYERS },
                React.createElement(FontAwesome_1.FA, { icon: "eye", left: true }),
                "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432\u0441\u0435\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.ACTION_EXPORT_SUBSCRIBERS },
                React.createElement(FontAwesome_1.FA, { icon: "comment-alt", left: true }),
                "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0434\u043B\u044F \u0440\u0430\u0441\u0441\u044B\u043B\u043E\u043A")));
    };
    PlayersList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, menu: { create: this.getNewButtonActionsDropDownMenu() }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ButtonDoExportXLS_1.default, { hint: "Экспорт списка игроков", onClick: function () { _this.doExportAllPlayers(); }, menu: this.getExportActionsDropDownMenu() }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allTags, availBrands: this.props.availTags, captions: { checkbox: "Все метки", placeholder: "Выберите метку" }, selectedBrands: this.props.tagsList, onBrandFilterChanged: this.onTagFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return (React.createElement(PlayerDetailExpander_1.default, { player: record, state: _this.props.state })
                /*<div style={{ margin: 0 }}>
                    
                    <div><b>Идентификатор записи:</b> [{record.key}] </div>
                    <div><b>Создан:</b> [{record.date_added.format(this.props.state.getDateTimeFormat())}]</div>
                    <div><b>Изменен:</b> [{record.date_changed.format(this.props.state.getDateTimeFormat())}]</div>
                    <div><b>Валюта:</b> [{record.app_currency_title}]</div>
                    <div><b>Язык интерфейса:</b> [{record.app_language_title}]</div>
                    <div><b>Баланс деньги:</b> [{record.money_balance}]</div>
                    <div><b>Баланс пойнты:</b> [{record.points_balance}]</div>
                    <div><b>ЕМэйл подтвержден:</b> [{this.bool2Str(record.is_email_confirmed)}]</div>
                    <div><b>Верифицирован:</b> [{this.bool2Str(record.is_verifed)}]</div>

                    <div><b>Сумма ставок:</b> [{record.total_bet_amount.toFixed(2)}]</div>

                    <div><b>Карты разрешены:</b> [{this.bool2Str(record.is_cards_allowed)}]</div>
                    <div><b>Описание:</b> [{record.description}]</div>

                    <div><b>Самоисключение:</b> [{this.bool2Str(record.is_self_exclude)}]</div>
                    <div><b>Дата самоисключения:</b> [{this.getSelfExcludeText(record)}]</div>

                    <div><b>Недельный лимит депозита:</b> [{this.bool2Str(record.is_self_deposit_week_limit)}]</div>
                    <div><b>Сумма лимита депозита:</b> [{record.self_deposit_week_limit_amount}]</div>
                    <div><b>Страна:</b> [{record.country}]</div>
                    <div><b>Город:</b> [{record.city}]</div>
                    <div><b>Адрес:</b> [{record.address}]</div>
                    <div><b>Аффилейт:</b> [{record.affilate_title}]</div>
                    <div><b>Партнер:</b> [{record.partner_login}]</div>
                    <div><b>Оффер:</b> [{record.partner_offer_title}]</div>
                    <div><b>Трекер:</b> [{record.partner_tracker_title}]</div>
                    <div><b>Игрок подписан на EMail рассылку:</b> [{this.bool2Str(record.is_agree_on_email_subscription)}]</div>
                    <div><b>Игрок использует отдельную зону:</b> [{this.bool2Str(record.is_custom_zone)}]</div>
                    <div><b>Зона игрока:</b> [{record.custom_gameprovider_zone_title}]</div>
                </div>*/
                ); }, scroll: { x: true } })));
    };
    return PlayersList;
}(React.Component));
exports.default = PlayersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/PlayersList.tsx
// module id = 1918
// module chunks = 0